var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/solid/location 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.1666C10.75 15.1666 14.5 11.032 14.5 7.75918C14.5 4.48638 11.8137 1.83325 8.5 1.83325C5.18629 1.83325 2.5 4.48638 2.5 7.75918C2.5 11.032 6.25 15.1666 8.5 15.1666ZM8.5 9.83325C9.60457 9.83325 10.5 8.93782 10.5 7.83325C10.5 6.72868 9.60457 5.83325 8.5 5.83325C7.39543 5.83325 6.5 6.72868 6.5 7.83325C6.5 8.93782 7.39543 9.83325 8.5 9.83325Z",
    fill: "#001E60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation4);
export default __webpack_public_path__ + "static/media/location 4.31df5d1e581208c99e02a6571a3c9d11.svg";
export { ForwardRef as ReactComponent };